export default __webpack_public_path__ + "static/media/nominapp.e8383ac7.svg";